module.exports = __webpack_public_path__ + "img/accepted.df1d78a5.svg";